import React, { useState, useEffect } from 'react';
import styles from './AddServiceModal.module.css';

const AddServiceModal = ({ services, contractorServices, onSave, onClose }) => {
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    // Initialize selected services from contractor services
    const initialSelected = contractorServices.map(service => service.id);
    setSelectedServices(initialSelected);
    setSelectAll(initialSelected.length === services.length && services.length > 0);
  }, [contractorServices, services]);

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      setSelectedServices(services.map(service => service.id));
    } else {
      setSelectedServices([]);
    }
  };

  const handleServiceToggle = (serviceId, checked) => {
    if (checked) {
      setSelectedServices(prev => [...prev, serviceId]);
    } else {
      setSelectedServices(prev => prev.filter(id => id !== serviceId));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(selectedServices);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <button type="button" className={styles.closeBtn} onClick={handleClose}>
            &times;
          </button>
          <h4 className={styles.modalTitle}>Add service</h4>
        </div>
        
        <div className={styles.modalBody}>
          <form onSubmit={handleSubmit}>
            <fieldset className={styles.formHorizontal}>
              {services.length > 0 ? (
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th>Service</th>
                      <th className={styles.textCenter}>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className={styles.bold}>Select All</td>
                      <td>
                        <input 
                          type="checkbox" 
                          id="select_all" 
                          className={styles.checkbox}
                          checked={selectAll}
                          onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                      </td>
                    </tr>
                    {services.map((service) => (
                      <tr key={service.id}>
                        <td>{service.name}</td>
                        <td>
                          <input 
                            type="checkbox"
                            name="services[]"
                            className={styles.checkbox}
                            checked={selectedServices.includes(service.id)}
                            onChange={(e) => handleServiceToggle(service.id, e.target.checked)}
                            value={service.id}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td></td>
                      <td className={styles.textRight}>
                        <button type="submit" className={styles.btnHead}>
                          <i className={styles.glyphiconPlus}></i> Manage Service
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              ) : (
                <p>No service to select.</p>
              )}
            </fieldset>
          </form>
        </div>
        
        <div className={styles.modalFooter}>
          <button type="button" className={styles.btnDefault} onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddServiceModal; 